import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';

const EmojiGraph = ({ data, emoji, isEnd, inView }) => {
	const emojiNumber = number => {
		let emojiDiv = [];

		for (let i = 0; i < number; i++) {
			emojiDiv.push(
				<div
					style={{
						transitionDelay: `${i * 0.025}s`
					}}
					className={s.emoji}
				>
					{emoji}
				</div>
			);
		}

		return emojiDiv;
	};

	return (
		<LineWrapper isEnd={isEnd} topTight>
			<div className={cn(s.container, { [s.hidden]: !inView })}>
				{data.map((data, index) => (
					<div className={s.emojiWrapper}>{emojiNumber(data.number)}</div>
				))}
			</div>
		</LineWrapper>
	);
};

export default EmojiGraph;



// WEBPACK FOOTER //
// ./components/EmojiGraph/index.js